import { useVariableInputStore } from "../../../store/variableInput.store";
import { stringContainsValidVariable } from "../../../utils/node.util";
import { z } from "zod";

export const httpActionNodeSchema = z.object({
  nodeId: z.string(),
  actionName: z
    .string()
    .min(1, "Please enter valid name")
    .max(45, "Name should be precise and less than 45 characters")
    .regex(
      /^[a-zA-Z0-9_ -]*$/,
      "Name can only contain alphanumeric characters, `-` and `_`",
    ),
  actionPurpose: z.string().optional(),
  method: z.enum(["GET", "POST", "PUT", "PATCH", "DELETE"], {
    errorMap: () => ({
      message: "Please select a valid method",
    }),
  }),
  url: z
    .string()
    .url("Please enter valid URL")
    .refine((value) => {
      const validVariables = useVariableInputStore.getState().variables;
      return stringContainsValidVariable(value, validVariables);
    }, "Incorrect Variable used"),
  headers: z.array(
    z.object({
      key: z.string(),
      value: z.string().refine((value) => {
        const validVariables = useVariableInputStore.getState().variables;
        return stringContainsValidVariable(value, validVariables);
      }, "Incorrect Variable used"),
    }),
  ),
  params: z.array(
    z.object({
      key: z.string(),
      value: z.string().refine((value) => {
        const validVariables = useVariableInputStore.getState().variables;
        return stringContainsValidVariable(value, validVariables);
      }, "Incorrect Variable used"),
    }),
  ),
  responseFields: z.array(
    z.object({
      path: z.string(),
      attributeId: z.string(),
      responseValue: z.unknown(),
    }),
  ),
  body: z
    .string()
    .refine((value) => {
      const validVariables = useVariableInputStore.getState().variables;
      return stringContainsValidVariable(value, validVariables);
    }, "Incorrect Variable used")
    .optional(),
  paths: z
    .array(
      z.object({
        type: z.enum(["success", "failure"]),
      }),
    )
    .default([{ type: "success" }, { type: "failure" }]),
  isValid: z.boolean().default(true),
});

export type HttpActionNodeSchema = z.infer<typeof httpActionNodeSchema>;
